export default "__VITE_ASSET__DtqDPt1T__"